'use client'
import type React from 'react'
import { createContext, useCallback, useContext, useEffect, useState } from 'react'

interface BreadcrumbContextValue {
  labels: Record<string, string>
  setBreadcrumbLabel: (routeKey: string, label: string) => void
}

const BreadcrumbContext = createContext<BreadcrumbContextValue>({
  labels: {},
  setBreadcrumbLabel: () => void 0,
})

export const BreadcrumbProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [labels, setLabels] = useState<Record<string, string>>({})
  const setBreadcrumbLabel = useCallback((routeKey: string, label: string) => {
    setLabels(prev => (prev[routeKey] === label ? prev : { ...prev, [routeKey]: label }))
  }, [])
  return (
    <BreadcrumbContext.Provider value={{ labels, setBreadcrumbLabel }}>
      {children}
    </BreadcrumbContext.Provider>
  )
}

export const useBreadcrumbContext = () => useContext(BreadcrumbContext)

export const useBreadcrumbLabel = (routeKey: string, label: string | undefined) => {
  const { setBreadcrumbLabel } = useBreadcrumbContext()
  useEffect(() => {
    if (label) setBreadcrumbLabel(routeKey, label)
  }, [routeKey, label, setBreadcrumbLabel])
}
